import { Component, OnInit } from '@angular/core';
import {
  PlansData,
  QuestionsData,
} from "../../../../shared/common/classes";
import { PlansManagementService } from "../../../../shared/services/plans-management.service";
import { Router, ActivatedRoute } from '@angular/router';
import { CustomCookieService } from '../../../../shared/services/custom-cookie.service';
import { fadeInOnEnterAnimation, fadeOutOnLeaveAnimation } from 'angular-animations';
import { SimpleAccordionData } from '../../../../shared/common/classes';

@Component({
  selector: 'app-select-plan',
  templateUrl: './select-plan.component.html',
  styleUrls: ['./select-plan.component.scss'],
  animations: [
    fadeInOnEnterAnimation(),
    fadeOutOnLeaveAnimation()
  ]
})
export class SelectPlanComponent implements OnInit {
  public plansData: any;
  // public plansData: PlansData[];
  public questionsData: QuestionsData[];
  public showPopOver: boolean;
  public dropdownData: SimpleAccordionData[];

  public selectedPlan: PlansData | null;
  public preSelectedPlan: PlansData;
  public mdn: string;

  constructor(
    private plansManagementService: PlansManagementService,
    private router: Router,
    private customCookieService: CustomCookieService,
    private activatedRoute: ActivatedRoute
  ) {
  }

  ngOnInit(): void {
    this.plansManagementService.getPlanDropdownsData().subscribe((data) => {
      this.dropdownData = data;
    })
    this.activatedRoute.data.subscribe(({ data }) => {
      this.selectedPlan = data.activePlan;
      this.plansData = data.plansList.products;
    })
    this.getFAQ();
    this.mdn = this.customCookieService.getData('ui-selectedMdn', true);
  }


  private getFAQ(): void {
    this.plansManagementService.getFAQ().subscribe((observer: QuestionsData[]) => {
      this.questionsData = observer;
    })
  }

  scrollTElement(element: any): void {
    (document.getElementById(element) as HTMLElement).scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
  }

  //// POPOVERS BUTTONS CALLBACKS

  public onPopOverDecline() {
    this.showPopOver = false;
  }

  public onPopOverAccept() {

  }


  /////// SELECT-PLAN SECTION CALLBACKS

  public onSelectPlan(plan: PlansData): void {
    this.plansManagementService.selectPlan(plan).subscribe()
    this.router.navigate(['/account/tnc']);
  }
  public onDetailsClick() {
    this.router.navigate(['/main/mdn-change-info']);
  }
}